import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=71810a7f&scoped=true"
import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=71810a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71810a7f",
  null
  
)

export default component.exports